<template>
  <base-page-component>
    <div>
      <b-row>
        <b-col md="12">
          <b-card>
            <div slot="header">Account Audit</div>
            <!-- User Interface controls -->
            <b-row>
              <b-col md="9" class="my-0">
                <b-form-group class="my-1">
                  <b-input-group v-on:keyup.enter="LoadDataCount">
                    <!--v-on:keyup.esc="ClearSearch"-->
                    <span class="mr-2" >Filter by: </span>
                    <b-form-input class="mr-2" @keydown.native="EscClearAccount" v-model="ACCOUNT_NUMBER" placeholder="Account #" />
                    <b-form-input class="mr-2" @keydown.native="EscClearUserName" v-model="USER_NAME" placeholder="User name" />
                    <b-form-input class="mr-2" @keydown.native="EscClearMessage" v-model="MESSAGE" placeholder="Message" />
                    <b-input-group-append>
                      <b-btn class="btn btn-default text-white mr-2" @click="ClearSearch">
                        <i class="fa fa-eraser" title="Clear Search"></i> <strong class="text-white">Clear all</strong>
                      </b-btn>
                      <b-btn class="btn btn-warning text-white mr-2" @click="LoadDataCount">
                        <i class="fa fa-search" title="Search"></i> <strong class="text-white">Search</strong>
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="3" class="my-1"><div class="mr-2" style="text-align:right">Showing {{ GetRowCount() }} / {{ totalCount }} records</div></b-col>
            </b-row>
            <!-- Main table element -->
            <b-table :items="Items" hover striped bordered small :fields="fields" :per-page="perPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" show-empty no-sort-reset>
              <template slot="ERROR_LOG_ID" slot-scope="row">
                {{row.value}}
              </template>
              <template slot="CREATED_TS" slot-scope="row">
                {{row.value | formatDate}}
              </template>
              <template slot="created_to_now" slot-scope="row">
                {{row.item.CREATED_TS | formatDateToNow}}
              </template>
              <template slot="ACCOUNT_NUMBER" slot-scope="row">
                <router-link :to="{ name: 'Account', params: { accountId: row.item.ACCOUNT_NUMBER }}">{{row.item.ACCOUNT_NUMBER}}</router-link>
              </template>
              <template slot="MESSAGE" slot-scope="row">
                <div v-if="row.item.IsJson">
                  <ul>
                    <li v-for="(item, index) in row.item.MESSAGE" :key="index">
                      {{ item }}
                    </li>
                  </ul>
                </div>
                <div v-else>
                  <ul>
                    <li>
                      {{row.item.MESSAGE}}
                    </li>
                  </ul>
                </div>
              </template>
            </b-table>
            <!-- NAV -->
            <nav>
              <b-pagination :total-rows="totalCount" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" />
            </nav>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </base-page-component>
</template>
<script>

import axios from 'axios';
import {basePageMixin} from '@/mixins/basePageMixin';
import moment from 'moment';

export default {
  components: {
  },
  mixins: [basePageMixin],
  data () {
    let self = this;
    return {
      ACCOUNT_NUMBER: self.$route.params.accountId,
      USER_NAME: undefined,
      MESSAGE: undefined,

      intervalHandle: undefined,
      gettingData: false,
      gettingDataInterval: 5000,
      totalCount: 0,
      Items: [],
      itemsObject: {},
      fields: [
        { key: 'ACCOUNTMANAGER_AUDIT_ID', label: 'Id', sortable: true },
        { key: 'CREATED_TS', label: 'Timestamp', sortable: true },
        { key: 'created_to_now', label: '', sortable: false },
        { key: 'USER_NAME', label: 'User Name', sortable: true },
        { key: 'ACCOUNT_NUMBER', label: 'Account #', sortable: true },
        { key: 'MESSAGE', label: 'Message', sortable: false }
      ],
      currentPage: 1,
      perPage: 15,
      sortBy: 'ACCOUNTMANAGER_AUDIT_ID',
      sortDesc: true,
    };
  },
  created () {
    let self = this;
    self.LoadDataCount(true);
  },
  methods: {
    LoadDataCount(onCreated) {
      let self = this;

      if (self.gettingData === false) {
        if (onCreated !== true) {
          self.boolLoading = true;
        }

        let obj = {
          ACCOUNT_NUMBER: self.ACCOUNT_NUMBER || '',
          USER_NAME: self.USER_NAME || '',
          MESSAGE: self.MESSAGE || '',
        }

        let axiosConfig = {
          timeout: 60000,
        }
        self.Items.splice(0);

        axios.post('/api/accounts/GetAuditDataCount', obj, axiosConfig)
          .then(response => {
            self.errMsg = '';
            self.showDismissibleAlert = false;
            self.totalCount = response.data[0].Total;
          })
          .catch(error => {
            self.handleError(error);
          }).then(r => {
            self.toggleloader(false);
          })
      };
      self.LoadData(true);
    },
    LoadData (onCreated) {
      let self = this;

      if (self.gettingData === false) {
        if (onCreated !== true) {
          self.boolLoading = true;
        }

        let obj = {
          ACCOUNT_NUMBER: self.ACCOUNT_NUMBER || '',
          USER_NAME: self.USER_NAME || '',
          MESSAGE: self.MESSAGE || '',
          CurPage: self.currentPage,
          PerPage: self.perPage,
          SortBy: self.sortBy,
          SortDesc: self.sortDesc,
        }

        let axiosConfig = {
          timeout: 60000,
        }
        self.Items.splice(0);

        axios.post('/api/accounts/GetAuditData', obj, axiosConfig)
          .then(response => {
            self.errMsg = '';
            self.showDismissibleAlert = false;
            let data = response.data.map(function (current, index, array) {
              try {
                current.MESSAGE = JSON.parse(current.MESSAGE);
                current.IsJson = true;
                return current;
              } catch (e) {
                current.IsJson = false;
                return current;
              }
            })
            self.Items = data;
          })
          .catch(error => {
            self.handleError(error);
          }).then(r => {
            self.toggleloader(false);
          })
      }
    },
    GetRowCount () {
      let self = this;
      return self.Items.length;
    },
    ClearSearch () {
      let self = this;
      self.ACCOUNT_NUMBER = undefined;
      self.USER_NAME = undefined;
      self.MESSAGE = undefined;

      self.LoadDataCount();
    },
    EscClearAccount (event) {
      let self = this;
      if (event.key === 'Escape') {
        self.ACCOUNT_NUMBER = undefined;
      }
    },
    EscClearUserName (event) {
      let self = this;
      if (event.key === 'Escape') {
        self.USER_NAME = undefined;
      }
    },
    EscClearMessage (event) {
      let self = this;
      if (event.key === 'Escape') {
        self.MESSAGE = undefined;
      }
    }
  },
  watch: {
    currentPage: {
      handler: function(curPage) {
        let self = this;
        self.currentPage = curPage;
        self.LoadData(true);
      }
    },
    sortBy: {
      handler: function(sortBy) {
        let self = this;
        self.sortBy = sortBy;
        self.sortDesc = false;
        self.LoadData(true);
      }
    },
    sortDesc: {
      handler: function(sortDesc) {
        let self = this;
        self.sortDesc = sortDesc;
        self.LoadData(true);
      }
    },
  },
  filters: {
    formatDate: function (date) {
      var m = moment(date);
      if (m.isValid()) {
        return m.add(moment().utcOffset(), 'm').format('MM/DD/YYYY hh:mm:ss a');
      }
      return '';
    },
    formatDateToNow: function (date) {
      var m = moment(date);
      if (m.isValid()) {
        let localTime = m.add(moment().utcOffset(), 'm');
        return localTime.toNow(true) + ' ago';
      }
      return '';
    }
  },
}</script>
<style>

  .hidden_header {
    display: none;
  }

  .table-features > tbody > tr > td,
  .table-features > tbody > tr > th {
    border: 0;
    background-color: white;
    padding: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/views/AccountDetailAudit.vue